import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Avatar, Card, Descriptions, Empty, Modal, Tag } from "antd";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import Apibank from "../../api/Apibank";
import { t } from "i18next";
import { Table } from "antd";
import { SearchMain } from "../../components/Search";
import AppContext from "../../components/AppContext";
import { getRowClassName } from "../../helpers/getRowClassName";
import {
  confirmSwal,
  formatPromptPayNumber,
  hasPermission,
  openNotification,
  scrollToAntSpinContainer,
  showToast,
  SwalInputConfirm,
} from "../../utils";
import UpdateDataByRoute from "../../helpers/isUpdateDataByRoute";
import { getRandomuserParams } from "../../utils";
import { ColumnsApproveTopup, } from "../../components/Columns/colums-deposit";
import { withTranslation } from "react-i18next";
import DataSourceMainSearch from "./components/dataSource-main-Search";
import moment from "moment";
import Apiauth from "../../api/Apiauth";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { FormatDataCustomerJson } from "../../helpers/formatDataJson";
import { BankData } from "../../Data/BankData";
import { tagsBageStatus } from "../../helpers/tagsBage";
import Swal from "sweetalert2";
import SelectSearch from "../../components/Search/searchCustomer";
import { getFuncReSend } from "../../utils/funcCallback";
import { debounce } from "lodash";
class Index extends React.Component {
  static contextType = AppContext;
  modalRef = null;

  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      showDetailsModel: false,
      isMobile: window.innerWidth <= 768,
      dropdownPlacement: "bottomRight",
      isSearching: false,
      spinIcon: 0,
      isLoading: false,
      telephoneNumber: undefined,
      startDateSearch: null,
      endDateSearch: null,
      itemTransaction: undefined,
      dataTable: [],
      searchData: [],
      tableParamsSearch: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
      isDataCustomer: undefined,
      customer_uuid: undefined,
      disabled: true,
    };
    this.tableRef = React.createRef();
    this.setDataCustomer = this.setDataCustomer.bind(this);
    this.updateModalButtonState = this.updateModalButtonState.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.debouncedFetch = debounce(this.fetchData, 100);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.debouncedFetch();
    this.setState({ isLoading: true });
    window.addEventListener("resize", this.handleResize);
    if (this.context.setFetchApproveDataCallback) {
      this.context.setFetchApproveDataCallback(this.handleReloadDeposit);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  componentDidUpdate(prevProps, prevState) {
    const isCustomerSelected = !!this.state.isDataCustomer;
    const prevCustomerSelected = !!prevState.isDataCustomer;

    const newDisabledState = !isCustomerSelected;

    if (isCustomerSelected !== prevCustomerSelected) {
      //  ถ้า Modal เปิดอยู่ (this.modalRef ไม่ใช่ null) ให้อัปเดตปุ่มใน Modal ทันที
      if (this.modalRef) {
        this.updateModalButtonState(newDisabledState);
      }
    } else {
      if (this.modalRef) {
        this.updateModalButtonState(newDisabledState);
      }
    }
  }

  updateModalButtonState(isDisabled) {
    if (this.modalRef && this.modalRef.update) {
      this.modalRef.update({
        okButtonProps: { disabled: isDisabled },
      });
    }
  }
  handleReloadDeposit = () => {
    this.setState({ isLoading: true }, () => this.debouncedFetch());
  };
  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };

  fetchData = async () => {
    const { tableParams, activeTabKey1 } = this.state;
    const { setCountTransApproval, setReloading } = this.context;
    let now = new Date();
    const params = getRandomuserParams(tableParams);
    const itemParam = {
      limit: params.limit,
      offset: params.page,
      sort: "id",
      ...params.filters,
      orderby: params.orderby,
      status: "ONHOLD",
      order: params.order,
      startDate: moment(now).format("YYYY-MM-DD"),
      endDate: moment(now).format("YYYY-MM-DD"),
    };

    try {
      const res = await Apibank.get_data_deposit(itemParam);
      if (res?.data?.success) {
        let dataArray = [];
        let count = 0;
        if (activeTabKey1 === "tab1") {
          dataArray = res?.data?.data_transactions?.data?.rows || [];
          count = res?.data?.data_transactions?.data?.count || 0;
        } else if (activeTabKey1 === "tab2") {
          dataArray = res?.data?.data_create_deposits?.data?.rows;
          count = res?.data?.data_create_deposits?.data?.count || 0;
        }
        this.setState(
          (prevState) => ({
            dataTable: dataArray,
            tableParams: {
              ...prevState.tableParams,
              pagination: {
                ...prevState.tableParams.pagination,
                total: count,
                current: tableParams.pagination.current,
                pageSize: tableParams.pagination.pageSize,
              },
            },
          }),
          () => {
            setCountTransApproval(res?.data?.data_transactions?.data?.count);
            setReloading(false);
          },
        );
      } else {
        showToast("error", res.message || "Failed to fetch data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ dataTable: [] });
      showToast("error", "Error fetching data.");
    } finally {
      this.setState({ isLoading: false });
    }
  };
  handleSearch = (value) => {
    const startDate =
      value?.startDate && moment(value.startDate?.$d).isValid()
        ? moment(value.startDate?.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
    const endDate =
      value?.endDate && moment(value.endDate?.$d).isValid()
        ? moment(value.endDate?.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

    this.setState(
      (prevState) => ({
        isSearching: true,
        startDateSearch: startDate,
        endDateSearch: endDate,
        tableParamsSearch: {
          ...prevState.tableParamsSearch,
          pagination: { ...prevState.tableParamsSearch.pagination, current: 1 },
          filters: {
            ...prevState.tableParamsSearch.filters,
            ref: value?.searchText,
            searchData: value,
          },
        },
      }),
      async () => {
        await Promise.all([
          this.getSearchDataTransaction(),
          scrollToAntSpinContainer(),
        ]);
      },
    );
  };
  onUpdateAuto = async () => {
    await Promise.all([this.debouncedFetch()]);
  };

  resetModalState = () => {
    this.setState({
      isLoading: false,
      spinIcon: 0,
      telephoneNumber: undefined,
      isDataCustomer: undefined,
      itemTransaction: undefined,
      disabled: true,
    });
  };

  handleIsSearching = (_e) => {
    this.setState({ isSearching: _e });
  };

  getSearchDataTransaction = async () => {
    this.setState({ isLoading: true });
    const { tableParamsSearch } = this.state;
    const { startDate, endDate, status, type, searchText, typeSearch } =
      tableParamsSearch?.filters?.searchData || {};
    const params = getRandomuserParams(tableParamsSearch);

    let postData = {
      startDate:
        startDate && moment(startDate?.$d).isValid()
          ? moment(startDate?.$d).format("YYYY-MM-DD")
          : null,
      endDate:
        endDate && moment(endDate?.$d).isValid()
          ? moment(endDate?.$d).format("YYYY-MM-DD")
          : null,
      status,
      type,
      typeSearch,
      search: searchText,
      limit: params.limit,
      page: params.page,
    };

    try {
      const res = await Apiauth.searchTransaction(postData);
      if (res.data.success) {


        this.setState((prevState) => ({
          searchData: res?.data?.data_transactions || [],
          isLoading: false,
          tableParamsSearch: {
            ...prevState.tableParamsSearch,
            pagination: {
              ...prevState.tableParamsSearch.pagination,
              total: res?.data?.totalItems || 0,
            },
          },
        }), () => {
          scrollToAntSpinContainer();
        });
      } else {
        showToast("error", res.data?.message || "Failed to fetch search data.");
        this.setState({ searchData: [], isLoading: false });
      }
    } catch (error) {
      console.error("Error fetching search data:", error);
      this.setState({ searchData: [], isLoading: false });
      showToast("error", "Error fetching search data.");
    }
  };

  // Approve
  /**
   * ฟังก์ชันสำหรับแสดงข้อความแจ้งเตือนโดยใช้ Ant Design notification
   * @param {('success'|'error'|'warning'|'info')} type - ประเภทของ Toast (ใช้แทน icon)
   * @param {string} title - หัวข้อหลักของข้อความแจ้งเตือน
   * @param {string} text - รายละเอียดของข้อความแจ้งเตือน
   */
  handleSweetalert2 = (type, title, text) => {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  };
  getApproveTopup = async (item) => {
    const { isDataCustomer } = this.state;
    const { id } = item;
    if (this.modalRef) {
      this.modalRef.destroy();
    }
    if (!id) {
      this.resetModalState();
      return this.handleSweetalert2(
        "error",
        "เกิดข้อผิดพลาด!",
        "!ไม่พบข้อมูล ID",
      );
    }

    if (!isDataCustomer) {
      this.resetModalState();

      return this.handleSweetalert2(
        "error",
        "เกิดข้อผิดพลาด!",
        "!ไม่พบข้อมูลลูกค้า",
      );
    }

    let isConfirm = await confirmSwal(
      "question",
      `Add credit to: ${isDataCustomer.bank_code} - ${isDataCustomer.account_no} - ${isDataCustomer.name}?`,
    );

    if (!isConfirm) {
      this.resetModalState();
      return showToast("info", "cancelled.");
    }

    let postData = {
      transectionId: id,
      customer: isDataCustomer,
    };

    try {
      const res = await Apibank.approveDeposit(postData);
      if (res.status === 200) {
        openNotification(
          "success",
          "Approved",
          res.data.message || "Transaction Approved.",
        );
        this.debouncedFetch();
      } else {
        openNotification(
          "error",
          "Failed!",
          res.data.message || "Approve failed.",
        );
      }
    } catch (error) {
      console.log(error);
      let errorTxt = error?.message;
      let errorRes = error?.response?.data;
      if (errorRes) {
        errorTxt = errorRes?.message;
      }
      openNotification("error", `error_code: ${error.status}`, errorTxt);
    } finally {
      this.setState({ isLoading: false, spinIcon: 0 }, () =>
        this.resetModalState(),
      );
    }
  };

  setDataSearchCustomers = (item) => {
    let { value } = item;
    if (value) {
      this.setState({
        customer_uuid: value,
      });
    } else {
      this.setState({
        customer_uuid: undefined,
      });
    }
  };

  setDataCustomer = (item) => {
    if (item) {
      this.setState({ isDataCustomer: item });
    } else {
      this.setState({ isDataCustomer: undefined });
    }
  };

  // Modal Approve Topup
  formatDate = "YYYY-MM-DD HH:mm:ss";
  columnProps = {
    xxl: 1,
    xl: 1,
    lg: 1,
    md: 1,
    sm: 1,
    xs: 1,
  };
  closeModal = () => {
    if (this.modalRef) {
      this.modalRef.destroy();
      this.resetModalState();
      this.setState({ isLoading: false, spinIcon: 0 });
    }
  };
  handleApproveTopup = (key) => {
    if (!key) return alert("!ไม่พบข้อมูล");
    let {
      id,
      bank,
      created_at,
      fee,
      type,
      logUuid,
      status,
      amount,
    } = key || {};


    const { isMerchantData } = this.context;

    this.setState({ isLoading: true, spinIcon: id, itemTransaction: key });
    let item = FormatDataCustomerJson(bank) || null;

    let i = isMerchantData;
    let merchantName = i?.name;

    let formAcc = item?.bankCode
      ? BankData.find((o) => o.bankCode === item?.bankCode)
      : null;
    let toAcc = item?.receivingBankCode
      ? BankData.find((o) => o.bankCode === item?.receivingBankCode)
      : null;

    let isAmount = Intl.NumberFormat().format(
      parseFloat(amount || 0).toFixed(2),
    );
    let isFee = Intl.NumberFormat().format(parseFloat(fee || 0).toFixed(2));

    const items = [
      {
        key: "8",
        label: "Merchant",
        children: <>{merchantName}</>,
      },
      {
        key: "1",
        label: "Date/Time",
        children: <>{moment(created_at).format("YYYY-MM-DD HH:mm:ss")}</>,
      },
      {
        key: "2",
        label: "Reference",
        children: <>{logUuid}</>,
      },
      {
        key: "3",
        label: "Type",
        children: <><Tag
          style={{ textTransform: "uppercase", fontWeight: "700" }}
          color={tagsBageStatus(type)}
          key={type}
        >
          {t(type)}
        </Tag></>,
      },
      {
        key: "4",
        label: "Sender",
        children: (
          <>
            {formAcc?.bankLogo && (
              <>
                <Avatar size="small" src={formAcc?.bankLogo} /> -
              </>
            )}
            {" "}{formatPromptPayNumber(item?.accountNo)}
            <br /> {item?.accountName}
          </>
        ),
      },
      {
        key: "11",
        label: "Receiver",
        children: (
          <>
            {toAcc?.bankLogo && (
              <>
                <Avatar size="small" src={toAcc?.bankLogo} /> -
              </>
            )}
            {" "}{formatPromptPayNumber(item?.receivingAccountNumber)}
            <br /> {item?.receivingAccountName}
          </>
        ),
      },
      {
        key: "5",
        label: "Amount",
        children: <>{isAmount}.-</>,
      },
      {
        key: "6",
        label: "Fee",
        children: <>{isFee}.-</>,
      },
      {
        key: "7",
        label: "Status",
        children: (
          <Tag
            style={{ textTransform: "uppercase", fontWeight: "700" }}
            color={tagsBageStatus(status)}
            key={status}
          >
            {t(status)}
          </Tag>
        ),
      },

      {
        key: "9",
        label: "",
        children: <b>{"Approve Topup"}</b>,
        style: { backgroundColor: "#70c1ff4d" },
      },
      {
        key: "10",
        style: { textAlign: "center" },
        label: <span className="text-center">{"To"}</span>,
        children: (
          <>
            <label style={{ width: "100%" }}>
              <SelectSearch
                typeSearch={"account_no"}
                onCustomerSelected={this.setDataSearchCustomers}
                isMobile={this.state.isMobile}
                setDataCustomer={this.setDataCustomer}
              />
              <br />
              <small style={{ fontSize: "12px", color: "red" }}>
                * เลือกลูกค้า ที่ต้องการทำรายการฝาก ,<br />* Select the customer
                you wish to make a deposit with.
              </small>
            </label>
          </>
        ),
      },
    ]; //
    this.modalRef = Modal.confirm({
      title: (
        <>
          <ExclamationCircleOutlined /> {"Detail Transaction"}
        </>
      ),
      width: 550,
      style: { top: 20 },
      icon: null,
      content: (
        <>
          <br />
          <Descriptions
            span={12}
            size="small"
            bordered
            column={this.columnProps}
            items={items}
          />
        </>
      ),
      onCancel: this.closeModal,
      onOk: () => this.getApproveTopup(key),
      okButtonProps: { disabled: this.state.disabled },
      okText: (
        <span style={{ textTransform: "uppercase" }}>{t("Approve")}</span>
      ),
      styles: {
        footer: {
          textTransform: "uppercase",
        },
      },
      cancelText: (
        <span style={{ textTransform: "uppercase" }}>{t("cancel")}</span>
      ),
    });
  };
  handleRejected = async (key, status, column) => {
    if (!key) return alert("!ไม่พบข้อมูล");
    try {
      const { id, merchantId, bank } = key;
      if (!id) {
        return this.handleSweetalert2(
          "error",
          "เกิดข้อผิดพลาด!",
          "!ไม่พบข้อมูล ID",
        );
      }
      this.setState({ isLoading: true, spinIcon: id });

      const parsedData = JSON.parse(bank);
      let findbank = BankData.find((o) => o?.bankCode === parsedData?.bankCode);

      const bankDisplay = findbank ? findbank?.bankCode : parsedData?.bankCode;

      const result = await SwalInputConfirm(
        "question",
        `Do you want to reject it?`,
        `${bankDisplay} - ${parsedData?.accountNo} - ${parsedData?.accountName}?`,
      );

      if (!result || !result.isConfirmed) {
        return showToast("info", "cancelled.");
      }

      let payload = {
        id: id,
        merchantId: merchantId,
        note: result?.value || "",
        status: status,
      };

      const res = await Apibank.getRejectDepositOnHold(payload);
      if (res.status === 200) {
        openNotification(
          "success",
          "Successfully",
          res.data.message || "Reject transaction completed.",
        );
        if (column === "Search") {
          this.getSearchDataTransaction();
        } else {
          this.debouncedFetch();
        }
      } else {
        openNotification(
          "error",
          "Failed!",
          res.data.message || "Reject transaction failed.",
        );
      }
    } catch (error) {
      console.log(error);
      let errorTxt = error?.message;
      let errorRes = error?.response?.data?.message;
      if (errorRes) {
        errorTxt = errorRes;
      }
      openNotification("error", `error_code: ${error.status}`, errorTxt);
    } finally {
      this.setState({ isLoading: false, spinIcon: 0 });
    }
  };


  handleReSend = async (item) => {
    if (item === "Not allowed") return alert("Not authorized.");
    const id = item?.id;
    if (!id) return showToast("error", "Id not found");

    this.setState({ isLoading: true, spinIcon: id });

    const result = await Swal.fire({
      title: "Do you want to Re Send?",
      text: "Press 'Confirm' to confirm the action",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.props.t("Confirm"),
      cancelButtonText: this.props.t("Cancel"),
    });

    if (result.isConfirmed) {
      const res = await getFuncReSend(id);
      if (res) this.debouncedFetch();
    }
    this.setState({ isLoading: false, spinIcon: 0 });
  };
  render() {
    const { i18n } = this.props;
    // ป้องกันกรณี i18n หรือ language เป็น undefined
    const currentLanguage = i18n?.language || "en";

    // ตรวจสอบให้แน่ใจว่าเป็น string ก่อนเอาไปใช้กับ Moment
    let tFormat = typeof currentLanguage === 'string' ? currentLanguage : "en";

    let languageFormat = tFormat === "lao" ? "lo" : tFormat;
    const { handleApproveTopup, handleRejected, handleReSend } = this;

    const { activeKey1, resProfileAdmin } = this.context;
    const {
      activeTabKey1,
      isLoading,
      tableParams,
      dataTable,
      isSearching,
      searchData,
      tableParamsSearch,
      spinIcon,
      startDateSearch,
      endDateSearch,
    } = this.state;
    const onTab1Change = (key) => {
      this.handleIsSearching(false);
      this.setState((prevState) => ({
        isLoading: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
        },
      }));
      this.setState({ activeTabKey1: key, isLoading: true });
    };

    const handleTableChange = (pagination, filters, sorter) => {
      this.setState(
        (prevState) => ({
          isLoading: true,
          tableParams: {
            ...prevState.tableParams,
            pagination,
            filters,
            sortField: sorter.field,
            sortOrder: sorter.order,
          },
        }),
        async () => {
          scrollToAntSpinContainer();
          await Promise.all([this.debouncedFetch()]);
        },
      );
    };
    const handleTableSearchChange = (pagination, filters, sorter) => {
      this.setState(
        (prevState) => ({
          isLoading: true,
          tableParamsSearch: {
            ...prevState.tableParamsSearch,
            pagination,
            filters: {
              ...prevState.tableParamsSearch.filters,
              ...filters,
            },
            sortField: sorter.field,
            sortOrder: sorter.order,
          },
        }),
        async () => {
          scrollToAntSpinContainer();
          await Promise.all([this.getSearchDataTransaction()]);
        },
      );
    };
    const displayStartDate = isSearching
      ? startDateSearch
      : moment(tableParams.filters.startDate).format("YYYY-MM-DD");
    const displayEndDate = isSearching
      ? endDateSearch
      : moment(tableParams.filters.endDate).format("YYYY-MM-DD");

    const tabList = [
      {
        key: "tab1",
        tab: (
          <>
            {!isSearching ? (
              t("transaction_list_all")
            ) : (
              <>
                {t("transaction_list_search", {
                  date: `${displayStartDate} - ${displayEndDate}`,
                })}
              </>
            )}
            {" : "} (
            {!isSearching
              ? Intl.NumberFormat().format(tableParams?.pagination?.total)
              : Intl.NumberFormat().format(
                tableParamsSearch?.pagination?.total,
              )}{" "}
            {this.props.t("items")})
          </>
        ),
      },
    ];
    const userPermissions = Array.isArray(resProfileAdmin?.permissions) ? resProfileAdmin.permissions : [];

    const accessible_approve = hasPermission(userPermissions, "approve_payin");
    const accessible_reject = hasPermission(userPermissions, "reject_payin");

    const columns = ColumnsApproveTopup(
      t,
      handleApproveTopup,
      handleRejected,
      spinIcon,
      languageFormat,
      accessible_approve,
      accessible_reject,
      handleReSend
    );

    const contentList = {
      tab1: (
        <>
          <Table
            className="col-lg-12"
            columns={columns}
            rowKey={(record) => record.id}
            onChange={handleTableChange}
            dataSource={dataTable}
            loading={isLoading}
            rowClassName={getRowClassName}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={t("No data")}
                />
              ),
            }}
            pagination={{
              ...tableParams.pagination,
              showSizeChanger: true,
              locale: {
                items_per_page: `/ ${t("paged")}`,
              },
              showTotal: (total, range) => {
                // คำนวณหน้าปัจจุบัน
                const currentPage = tableParams.pagination.current;
                // คำนวณจำนวนหน้าทั้งหมด
                const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                return (
                  <span>
                    {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                    <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                    <span style={{ marginLeft: 10 }}>
                      {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                    </span>
                  </span>
                );
              },
            }}
            scroll={{ x: "max-content" }}
          />
        </>
      ),
    };
    const type = "deposit";
    const status = "ONHOLD";

    return (
      <>
        <UpdateDataByRoute onUpdateAuto={this.onUpdateAuto} />
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("Approve transaction")}
                Breadcrumb={[
                  {
                    name: removeSlashesFromPath(window.location.pathname),
                  },
                ]}
              />
              <SearchMain
                t={t}
                type={type}
                status={status}
                onSearch={this.handleSearch}
                handleIsSearching={this.handleIsSearching}
                activeKey1={activeKey1}
              />
              <Card
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={onTab1Change}
              >

                {!isSearching ? (
                  contentList[activeTabKey1]
                ) : (
                  <DataSourceMainSearch
                    columns={columns}
                    dataSource={searchData}
                    isSearching={isSearching}
                    getRowClassName={getRowClassName}
                    onChange={handleTableSearchChange}
                    tableParams={tableParamsSearch}
                    handleIsSearching={this.handleIsSearching}
                    loading={isLoading}
                  />
                )}
                <ul>
                  <li style={{ color: "#888" }}>
                    <small>
                      {t("The system will update data every 1.30 minutes.")}
                    </small>
                  </li>
                  <li style={{ color: "#888" }}>
                    <small>{t("topup_instruction_remark")}</small>
                  </li>
                </ul>
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});
export default connect(mapStateToProps, {})(withTranslation()(Index));
